import React from 'react'
import { Outlet } from 'react-router-dom'

const UserMainBar = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default UserMainBar